<eui-toolbar-item>
    <eui-user-profile euiUserProfileSizeS [hasWelcomeLabel]="hasWelcomeLabel" [welcomeLabel]="welcomeLabel"
                      [impersonateLabel]="impersonateLabel"
                      [avatarUrl]="avatarUrl">
        <ng-content select="eui-user-profile-menu"></ng-content>
    </eui-user-profile>
</eui-toolbar-item>
